import React from "react";
import { Box, Container, Link, Typography } from "@material-ui/core";
import { useDomainFeatures } from "../../context/DomainFeaturesContext";

const bodyStyle = { lineHeight: 1.8, color: "#334155" };
const headingStyle = { fontWeight: 700, color: "#0F3B62", marginTop: 24 };

export default function RefundCancellationPolicy() {
  const { supportEmail, brandDomain } = useDomainFeatures();
  const brandLabel =
    brandDomain.charAt(0).toUpperCase() + brandDomain.slice(1);
  return (
    <Container maxWidth="md" style={{ paddingTop: 24, paddingBottom: 40 }}>
      <Typography
        variant="h4"
        component="h1"
        align="center"
        style={{ fontWeight: 700, color: "#0F3B62" }}
      >
        Refund and Cancellation Policy
      </Typography>
      <Box mt={3}>
        <Typography variant="body1" style={bodyStyle}>
          This Refund and Cancellation Policy (&quot;Policy&quot;) governs payments,
          cancellations, transfers, and refunds for services offered by Montestory
          (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). By enrolling in our programs, you
          (&quot;user&quot;, &quot;parent&quot;, or &quot;guardian&quot;) agree to the terms
          outlined below.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          1. Fee Structure
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          Fees are calculated based on the number of enrolled students multiplied by the
          applicable price per student, as communicated at the time of enrolment. All fees
          are payable in advance unless otherwise specified.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          2. Cancellation Policy
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          Once enrolment is confirmed and payment is successfully processed, cancellations are
          not permitted. However, enrolment may be{" "}
          <strong>transferred to another student</strong> as a replacement, subject to prior
          written approval from {brandLabel}.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          3. Prorated Charges on Withdrawal
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          If a student withdraws during the academic year, fees will be calculated on a{" "}
          <strong>quarterly prorated basis</strong>. The applicable charges up to the end of the
          current quarter will be retained.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          4. No Refund Policy
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          All payments made to {brandLabel} are <strong>non-refundable</strong>, except where
          required under applicable law. No refunds will be issued for partial usage,
          non-attendance, or early withdrawal.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          5. Exceptions (If Applicable Under Law)
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          Nothing in this Policy shall limit any rights available to users under applicable
          laws, including but not limited to:
        </Typography>
        <Box component="ul" style={{ marginTop: 8, paddingLeft: 24, ...bodyStyle }}>
          <li>Consumer Protection Act, 2019</li>
          <li>Information Technology Act, 2000</li>
        </Box>
        <Typography variant="body1" style={{ ...bodyStyle, marginTop: 8 }}>
          In cases where a refund is mandated by law or ordered by a competent authority,
          {brandLabel} will comply accordingly.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          6. Payment Disputes
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          In the event of any payment disputes, users are encouraged to contact {brandLabel}
          first for resolution. Any chargebacks or disputes raised with payment providers must
          be supported by valid documentation.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          7. Limitation of Liability
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          {brandLabel} shall not be held liable for any indirect, incidental, or consequential
          damages arising from the use of its services, including but not limited to missed
          sessions or voluntary withdrawal.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          8. Governing Law and Jurisdiction
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          This Policy shall be governed by and construed in accordance with the laws of India.
          Any disputes arising under this Policy shall be subject to the exclusive jurisdiction
          of the courts located in Hyderabad, Telangana.
        </Typography>

        <Typography variant="h6" style={headingStyle}>
          9. Contact Information
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          For any queries, concerns, or requests regarding this Policy, please contact:
        </Typography>
        <Typography variant="body1" style={{ ...bodyStyle, marginTop: 8 }}>
          <strong>Email:</strong>{" "}
          <Link href={`mailto:${supportEmail}`} color="inherit" underline="always">
            {supportEmail}
          </Link>
        </Typography>
        {/* <Typography variant="body1" style={{ ...bodyStyle, marginTop: 8 }}>
          <strong>Address:</strong> 4-9-197, St no 7, HMT Nagar, Hyderabad 500076
        </Typography> */}

        <Typography variant="h6" style={headingStyle}>
          10. Taxes
        </Typography>
        <Typography variant="body1" style={bodyStyle}>
          Taxes are applicable as per law of land.
        </Typography>
      </Box>
    </Container>
  );
}
